<script lang="ts">
import type { StudyMarketStatsSlideProps } from '$lib/components/study/slide-layout-types'
import StudyBlueCalloutCard from '../cards/StudyBlueCalloutCard.svelte'
import StudySlideDoughnutCard from '../cards/StudySlideDoughnutCard.svelte'
import StudySlideStatTileCard from '../cards/StudySlideStatTileCard.svelte'
import BarChart from '../charts/BarChart.svelte'
import StudySlide from '../StudySlide.svelte'
import StudySlideContent from '../StudySlideContent.svelte'

/**
 * Chapter 02 “The Market” scale slide: eyebrow, headline, 4× `.sb` stat grid, doughnut + bar charts,
 * optional `StudyBlueCalloutCard` footnote. `eyebrow`, `headline`, and `footnote` body use `{@html}` — trusted study only (no outer `<p>`; card supplies the paragraph).
 */
let {
  id,
  active = false,
  extraBottom = false,
  contentClass = '',
  eyebrow,
  headline,
  statTiles,
  doughnut,
  bar,
  footnote,
  introHtml,
}: StudyMarketStatsSlideProps = $props()
</script>

<StudySlide {id} {active} {extraBottom}>
  <StudySlideContent maxWidth="960px" {contentClass}>
    <div class="ey">{@html eyebrow}</div>
    <div class="hl" style="margin-bottom:{introHtml ? '.6rem' : '1.2rem'};">
      {@html headline}
    </div>
    {#if introHtml}
      <p class="bd" style="margin-bottom:1.05rem;">{@html introHtml}</p>
    {/if}
    <div class="sg4" style="margin-bottom:1.05rem;">
      {#each statTiles as tile}
        <StudySlideStatTileCard {...tile} />
      {/each}
    </div>
    <div class="tc study-market-stats-slide__charts" style="gap:1.2rem;margin-bottom:1.2rem;">
      <StudySlideDoughnutCard {active} {...doughnut} />
      <div class="cc">
        <div class="ct">{@html bar.title}</div>
        {#if bar.subtitle}
          <div class="cs">{@html bar.subtitle}</div>
        {/if}
        <BarChart
          {active}
          labels={bar.labels}
          datasets={bar.datasets}
          showLegend={bar.showLegend}
          yTickFormat={bar.yTickFormat}
          tooltipFormat={bar.tooltipFormat}
          height={bar.height}
        />
      </div>
    </div>
    {#if footnote}
      <StudyBlueCalloutCard
        cardClass="study-market-stats-slide__footnote"
        cardStyle="margin-top:.55rem;"
        paragraphStyle="margin:0;font-size:.88rem;line-height:1.55;"
        bodyHtml={footnote}
      />
    {/if}
  </StudySlideContent>
</StudySlide>
